import { SupportRequest, SupportRequestType, SupportRequestStatus, ApiResponse } from '@court-sync/shared';
import { apiGet, apiPost, apiPut } from './apiClient';

export interface CreateSupportRequestData {
  type: SupportRequestType;
  subject: string;
  message: string;
  academyId?: string;
}

export interface UpdateSupportRequestData {
  subject?: string;
  message?: string;
}

export interface SupportRequestFilters {
  status?: SupportRequestStatus;
  type?: SupportRequestType;
}

export const supportService = {
  async createSupportRequest(data: CreateSupportRequestData): Promise<ApiResponse<SupportRequest>> {
    return apiPost<SupportRequest>('/support', data);
  },

  async getSupportRequests(filters?: SupportRequestFilters): Promise<ApiResponse<SupportRequest[]>> {
    const params: Record<string, string> = {};
    if (filters?.status) params.status = filters.status;
    if (filters?.type) params.type = filters.type;
    return apiGet<SupportRequest[]>('/support', { params });
  },

  async getSupportRequest(id: string): Promise<ApiResponse<SupportRequest>> {
    return apiGet<SupportRequest>(`/support/${id}`);
  },

  async updateSupportRequest(id: string, data: UpdateSupportRequestData): Promise<ApiResponse<SupportRequest>> {
    return apiPut<SupportRequest>(`/support/${id}`, data);
  },
};
